/**
 * Database sync management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class DBSyncManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async deployTask(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/sys_dbsync_task/deploy', { data });
  }

  async runTask(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/sys_dbsync_task/run', { data });
  }

  async retireTask(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/sys_dbsync_task/retire', { data });
  }

  async getConnectionSchemas(connectionId: string): Promise<Record<string, any>> {
    return this.session.get(`/api/cdp/dbsync_connection/schemas/get/${connectionId}`);
  }

  async getConnectionTables(connectionId: string): Promise<Record<string, any>> {
    return this.session.get(`/api/cdp/dbsync_connection/tables/get/${connectionId}`);
  }

  async getConnectionViews(connectionId: string): Promise<Record<string, any>> {
    return this.session.get(`/api/cdp/dbsync_connection/views/get/${connectionId}`);
  }

  async listJobLogs(page = 1, size = 20, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/sys_dbsync_job_log/page', {
      params: { current: page, size, ...params },
    });
  }
}
